export async function callPromiseAssert<T, A extends unknown[]>(
  method: ((...args: A) => Promise<T>) | undefined | null,
  name = "method",
  ...args: A
): Promise<T> {
  if (typeof method !== "function") {
    throw new Error(`Could not load promise ${name} because it was not available`);
  }

  return method(...args);
}
